import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import logoFull from '../assets/ufeus-logo-full.jpg';

export default function Footer() {
  return (
    <footer className="w-full py-14 px-6 md:px-8" style={{ backgroundColor: 'var(--bg-elevated)', borderTop: '1px solid var(--border-subtle)' }}>
      <div className="container-premium flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div className="flex flex-col gap-4 max-w-sm">
          <div className="h-16 overflow-hidden" style={{ width: '320px' }}>
            <img
              src={logoFull}
              alt="Ufeus Consultancy Services Pvt Ltd"
              className="h-full w-auto max-w-none"
              style={{ objectFit: 'cover', objectPosition: '0 52%', transform: 'scale(2.6)', transformOrigin: 'left center' }}
            />
          </div>
          <p className="t-sm" style={{ color: 'var(--text-muted)' }}>
            Software &amp; AI consultancy — minimal code, maximum impact.
          </p>
        </div>

        <div className="flex flex-col gap-2 t-sm" style={{ color: 'var(--text-secondary)' }}>
          <span className="t-label mb-1" style={{ color: 'var(--text-muted)' }}>Company</span>
          <a href="#about" className="hover:opacity-80 transition-opacity">About</a>
          <a href="#founders" className="hover:opacity-80 transition-opacity">Leadership</a>
          <a href="#careers" className="hover:opacity-80 transition-opacity">Careers</a>
          <a href="mailto:contact@ufeus.com" className="hover:opacity-80 transition-opacity">Contact</a>
        </div>

        <div className="flex flex-col gap-2 t-sm max-w-xs" style={{ color: 'var(--text-secondary)' }}>
          <span className="t-label mb-1" style={{ color: 'var(--text-muted)' }}>Registered Office</span>
          <span>Ufeus Consultancy Services Pvt Ltd</span>
          <span>14B, Konark Nagar, Solapur MH - 413003</span>
          <span style={{ color: 'var(--text-muted)' }}>CIN: U68200PN2023PTC220818</span>
          <a href="mailto:support@ufeus.com" className="hover:opacity-80 transition-opacity">support@ufeus.com</a>
          <a
            href="https://in.linkedin.com/company/ufeus-consultancy-service-pvt-ltd"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="mt-3 text-xl transition-opacity hover:opacity-80"
            style={{ color: 'var(--accent)' }}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </div>
      </div>

      <div className="container-premium mt-10 pt-6 t-label text-center" style={{ borderTop: '1px solid var(--border-subtle)', color: 'var(--text-muted)' }}>
        © {new Date().getFullYear()} Ufeus Consultancy Services Pvt Ltd. All rights reserved.
      </div>
    </footer>
  );
}
